import {createRouter, createWebHistory} from 'vue-router'
import Company from "@/views/Company.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import Land from "@/views/Land.vue";
import Park from "@/views/Park.vue";
import Favourites from "@/views/Favourites.vue";

const validCompanies = ['walt-disney-attractions', 'universal-parks-and-resorts'];

const validParks = {
  'walt-disney-attractions':
    [
      'animal-kingdom',
      'disney-california-adventure',
      'disney-hollywood-studios',
      'disney-magic-kingdom',
      'disneyland',
      'disneyland-park-paris',
      'epcot',
      'walt-disney-studios-paris',
      'disney-adventure-world-paris'
    ],
  'universal-parks-and-resorts':
    [
      'epic-universe',
      'islands-of-adventure-at-universal-orlando',
      'universal-studios-at-universal-orlando',
      'universal-studios-hollywood',
      'universal-volcano-bay'
    ]
}

const routes = [
  {
    path: '/',
    name: 'company',
    component: Company,
    meta: {title: 'Live Wait Times For Your Favourite Disney Rides'}
  },
  {
    path: '/:companySlug',
    name: 'land',
    component: Land,
    // The beforeEnter is a Vue Router specific navigation guard method - not general JS function.
    // Its part of the Vue Router API used to control navigation to a specific route
    beforeEnter: (to, from, next) => {
      if (validCompanies.includes(to.params.companySlug)) {
        next()
      } else {
        next({name: 'PageNotFound'});
      }
    },
    meta: {title: 'Choose Your Park'},
  },
  {
    path: '/:companySlug/:parkSlug',
    name: 'park',
    component: Park,
    beforeEnter: (to, from, next) => {
      const company = to.params.companySlug;
      const park = to.params.parkSlug;

      if (
        validCompanies.includes(company) &&  // Is company in valid companies?
        validParks[company] && // Does the company have valid parks defined?
        validParks[company].includes(park)) { // Is the park valid for this company?
        next(); // If all checks pass; proceed to the route
      } else {
        next({name: 'PageNotFound'}); // Checks not passed, invalid company or park; redirect to 404 page
      }
    },
    meta: {title: 'Rides'}
  },
  {
    path: '/favourites',
    name: 'favourites',
    component: Favourites,
    meta: {title: 'Favourites'}
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {title: 'Page not found'}
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {top: 0}
  }
})

router.beforeEach((to, from) => {
  const defaultTitle = 'Theme Park Buddy';
  document.title = "Theme Park Buddy" + " | " + to.meta.title || defaultTitle;
})

router.afterEach((to) => {
  if (window.gtag) {
    window.gtag('config', 'G-9EPPR3PPZV', {
      page_path: to.fullPath,
    });
  }
});
export default router;
